import React, { FC } from 'react';
import { classnames } from '@src/utils/classnames';
import { toUpperFirstSymbol } from '@src/utils/string';
import { Icon, TIconName } from '../Icon';
import { Tag } from '../Tag';
import { Text } from '../Text';
import { getClasses } from '@src/utils/getClass';

import style from './TariffBage.scss';

interface IProps {
  name: string;
  iconName: TIconName;
}

export const TariffBage: FC<IProps> = ({ iconName, name }) => {
  const view = name === 'Pro' ? 'black' : 'white';
  const classes = classnames(style.root, ...getClasses(style, { view }));

  return (
    <Tag id="tariffLabel" className={classes} variant="new">
      <Icon name={iconName} view="basicBlack" />
      <Text id={'requestTariffName'} weight="bold">
        {toUpperFirstSymbol(name)}
      </Text>
    </Tag>
  );
};
